import type { RouteRecordRaw } from 'vue-router';
import { AppPermissions } from '@/utils/permissions';

/**
 * Routes contributed by the CBT live monitoring feature. Mounted as children
 * of the admin dashboard route in `src/router/index.ts`.
 *
 * Gated on the `cbt_monitoring.view` permission (defined in the backend's
 * config/permission.php and the matching CBT_MONITORING entry in the
 * PermissionResourceEnum GraphQL enum).
 */
const monitoringViewPermission = {
  action: AppPermissions.CbtMonitoring.Actions.View,
  resource: AppPermissions.CbtMonitoring.Resource,
} as const;

export const cbtMonitoringRoutes: RouteRecordRaw[] = [
  {
    path: 'cbt/monitoring',
    name: 'admin-cbt-monitoring',
    component: () => import('./components/LiveMonitoringDashboard.vue'),
    meta: {
      requiresAuth: true,
      title: 'Live CBT Monitoring',
      permission: monitoringViewPermission,
    },
  },
  {
    path: 'cbt/monitoring/:testId',
    name: 'admin-cbt-monitoring-for-test',
    component: () => import('./components/LiveMonitoringDashboard.vue'),
    props: (route) => ({ testId: route.params.testId as string }),
    meta: {
      requiresAuth: true,
      title: 'Live CBT Monitoring',
      permission: monitoringViewPermission,
    },
  },
  {
    path: 'cbt/tests/:testId/recordings',
    name: 'admin-cbt-test-recordings',
    component: () => import('./components/TestRecordingsPage.vue'),
    meta: {
      requiresAuth: true,
      title: 'CBT Monitoring Recordings',
      permission: monitoringViewPermission,
    },
  },
];
